import { CostAdjustmentImportPage } from "@/features/inventory-adjustment/pages/CostAdjustmentImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/inventory-adjustment/cost-adjustment/import",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["inventory_adjustment.cost_import"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: CostAdjustmentImportPage,
});
